import { api } from '../lib/api.js';
import { Button, Card, MadeByAzkoGroup } from '../components/ui.js';

/**
 * O que o cliente ve quando a Azko cortou o acesso da conta.
 *
 * Existe por um motivo especifico: sem ela, o login BEM-SUCEDIDO de uma conta
 * suspensa devolvia a propria tela de login. O sindico digitava a senha certa,
 * voltava para o mesmo lugar, e concluia que tinha errado a senha — ligava para
 * o suporte descrevendo o problema errado, e ninguem descobria que a propria
 * Azko tinha cortado o acesso na vespera.
 *
 * A tela nao mostra botao de tentar de novo: recarregar nao resolve nada, e um
 * botao que nao resolve e pior que nenhum. O caminho e falar com a Azko, e o
 * unico controle e sair — para quem administra dois predios conseguir entrar
 * com outra conta.
 */
export function SuspendedPage({ message }: { message: string }) {
  async function signOut() {
    try {
      await api.post('/auth/logout');
    } finally {
      window.location.reload();
    }
  }

  return (
    <div className="safe-area-all safe-screen grid place-items-center px-5 py-12">
      <div className="w-full max-w-lg">
        <div className="flex items-center gap-3">
          <span className="grid size-11 place-items-center rounded-2xl bg-accent text-xl font-extrabold text-on-accent">
            A
          </span>
          <span>
            <span className="block text-sm font-extrabold uppercase tracking-wide">
              Azko Condos
            </span>
            <span className="block text-xs text-muted">Gestao de condominios</span>
          </span>
        </div>

        <Card className="mt-8 border-warn/40 p-6 sm:p-8">
          <p className="eyebrow" style={{ color: 'var(--color-warn)' }}>
            Acesso suspenso
          </p>
          <h1 className="mt-3 text-2xl font-extrabold tracking-tight">
            Sua conta esta temporariamente sem acesso.
          </h1>
          <p className="mt-3 text-sm text-muted">{message}</p>

          <div className="mt-6 border-t border-line-soft pt-5">
            <p className="text-sm font-semibold">O que a portaria faz enquanto isso</p>
            <p className="mt-2 text-sm text-muted">
              As encomendas ja registradas continuam guardadas e nada foi apagado. O
              historico volta exatamente como estava assim que o acesso for
              restabelecido.
            </p>
          </div>

          <Button variant="ghost" className="mt-6" onClick={() => void signOut()}>
            Sair
          </Button>
        </Card>

        <MadeByAzkoGroup className="mt-10" />
      </div>
    </div>
  );
}
